import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { TableListComponent } from '../../../../shared/components/table-list/table-list.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTableModule } from '@angular/material/table'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { ContractItemService } from '../../../../core/services/contract/contract-item/contract-item.service'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { ServiceOrderService } from '../../../../core/services/service/service-order/service-order.service'

@Component({
  selector: 'itinerary-service-order-modal',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner,
    MatTableModule,
    TableListComponent,
    MatProgressBar,
    NgxMaskDirective,


  ],
  templateUrl: './itinerary-modal.component.html',
  styleUrl: './itinerary-modal.component.scss',
  providers: [DocumentTypeService, ViaCepService, provideNgxMask({
    dropSpecialCharacters: false
  })],
  standalone: true,
})
export class ItineraryModalComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private documentTypeService: DocumentTypeService,
    private addressTypeService: AddressTypeService,
    private viaCepService: ViaCepService,
    private contractItemService: ContractItemService,
    private itinerariesService: ItinerariesService,
    private ordemService: ServiceOrderService,
  ) { }



  form!: FormGroup;
  itemsList: any[] = [];
  @Output() response = new EventEmitter<any>()
  @Input() editItem: any = {}
  @Input() idItemContract = -1
  @Input() idItemPropose = -1
  listType: any[] = []
  documentTypeList: any[] = []
  itineraryList: any[] = []
  loading = false;



  editIndex: number | null = null;
  editAgendaItem: any = null;
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  cepMask = '00000-000';


  columns: any[] = [
    { keyColumn: 'localParada', key: 'localParada', description: 'Local' },
    { keyColumn: 'cep', key: 'cep', description: 'Cep' },
    { keyColumn: 'logradouro', key: 'logradouro', description: 'Logradouro' },
    { keyColumn: 'numero', key: 'numero', description: 'Número' },
    { keyColumn: 'bairro', key: 'bairro', description: 'Bairro' },
    { keyColumn: 'cidade', key: 'cidade', description: 'Cidade' },
    { keyColumn: 'areaTarifario', key: 'areaTarifario', description: 'Área Tarifario' },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ];

  displayedColumns = this.columns.map((col) => col.keyColumn);


  ngOnInit(): void {
    this.listTypeAddress()
    this.createForm()
    if (this.data && this.data.contratoItemId) {
      this.idItemContract = this.data.contratoItemId;
    }
    // this.searchItinerary()
    if (this.data?.contratoItemId) {
      this.idItemContract = this.data.contratoItemId;
      this.contractItemService.getContractItembyId(this.idItemContract).subscribe({
        next: (res) => {
          this.idItemPropose = res.data.itemPropostaId;
          this.listPagedItinerary(); // chame aqui com base no idItemPropose
        },
        error: (err) => console.error('Erro ao buscar contrato item:', err)
      });
    }
  }

  getItemProposeId(): void {
    this.loading = true;
    this.contractItemService.getContractItembyId(this.idItemContract).subscribe({
      next: (res) => {
        this.idItemPropose = res.data.itemPropostaId;
        this.listItineraries();
      },
      error: (err) => {
        console.error('Erro ao obter itemPropostaId', err);
        this.loading = false;
      }
    });
  }

  listItineraries(): void {
    this.itinerariesService.listPagedItinerariesByItemPropose(this.idItemPropose, this.rows)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data || [];
          this.numberRows = this.itemsList.length;
          this.loading = false;
        },
        error: (err) => {
          console.error('Erro ao listar itinerários', err);
          this.itemsList = [];
          this.loading = false;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  handleTableResponse(event: any) {
    this.itemsList = event;
  }

  listTypeAddress() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  getAddressByPostalCode(): void {
    const postalCode = this.form.get('postalCode')?.value;
    if (postalCode && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (res) => this.fillFormViaCep(res),
        error: (err) => console.error('Erro ao buscar endereço', err)
      });
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('addressType')?.setValue(this.editItem.tipo_endereco_id)
    this.form.get('postalCode')?.setValue(this.editItem.cep)
    this.form.get('street')?.setValue(this.editItem.logradouro)
    this.form.get('number')?.setValue(this.editItem.numero)
    this.form.get('neighborhood')?.setValue(this.editItem.bairro)
    this.form.get('city')?.setValue(this.editItem.cidade)
    this.form.get('country')?.setValue(this.editItem.pais)
    this.form.get('state')?.setValue(this.editItem.estado)
    this.form.get('latitude')?.setValue(this.editItem.latitude)
    this.form.get('longitude')?.setValue(this.editItem.longitude)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.get('street')?.setValue('')
      this.form.get('number')?.setValue('')
      this.form.get('neighborhood')?.setValue('')
      this.form.get('city')?.setValue('')
      this.form.get('state')?.setValue('')
      this.form.get('country')?.setValue('')
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  getDocumentTypes() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (res) => {
        this.documentTypeList = res.data; // Use the correct property that contains the array
      },
      error: (err) => {
        // trate o erro se necessário
        this.documentTypeList = [];
      }
    });
  }

  closeModal() {
    this.dialog.getDialogById('itinerary-service-order-modal')?.close();
  }

  listPagedItinerary() {
    this.loading = true;
    this.ordemService.getServiceOrderItineraryStopbyId(this.data.idOs, this.rows, this.page)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data ?? [];
          this.numberRows = this.itemsList.length;
          this.loading = false;
        },
        error: (err) => {
          this.itemsList = [];
          this.numberRows = 0;
          this.loading = false;
          console.error("Erro ao buscar itinerários:", err);
        }
      });
  }


  searchItinerary() {
    this.loading = true;
    this.contractItemService.getContractItembyId(this.idItemContract)
      .subscribe({
        next: (res) => {
          this.idItemPropose = res.data.itemPropostaId;
          this.itinerariesService.listPagedItinerariesByItemPropose(this.idItemPropose, this.rows)
            .subscribe({
              next: (res) => {
                this.treatResponse(res)
              },
              error: (err) => {
                this.loading = false;
                this.itineraryList = []
              }
            })
        },
        error: (err) => {
        }

      })
  }




  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }



  createForm(): void {
    this.form = this.formBuilder.group({
      local: ['', Validators.required],
      postalCode: ['', Validators.required],
      street: [''],
      state: [''],
      number: [''],
      neighborhood: [''],
      city: [''],
      country: ['Brasil'], // Valor default
      latitude: [''],
      longitude: [''],
    })
  }

  getAddressTypeDescription() {
    const addressTypeId = this.form.get('addressType')?.value
    if (addressTypeId) {
      const element = this.listType.find((ele: any) => {
        return ele.id === addressTypeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createAddress() {

    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const item = this.form.value;
    this.response.emit(item);
    this.form.reset();
  }

  startEdit(item: any) {
    if (!item) return;
    const index = this.itemsList.findIndex(i =>
      i.local === item.local &&
      i.cep === item.cep &&
      i.numero === item.numero
      // adicione outros campos se necessário
    );
    if (index === -1) return;
    this.editIndex = index;
    this.form.patchValue({
      local: item.local ?? '',
      postalCode: item.cep ?? '',
      street: item.logradouro ?? '',
      number: item.numero ?? '',
      neighborhood: item.bairro ?? '',
      city: item.cidade ?? '',
      state: item.estado ?? '',
      country: item.pais ?? '',
      latitude: item.latitude ?? '',
      longitude: item.longitude ?? '',
    });
  }

  editAddress() {
    if (this.editIndex === null || this.editIndex === undefined) return;
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const item = {
      local: this.form.value.local,
      cep: this.form.value.postalCode,
      logradouro: this.form.value.street,
      numero: this.form.value.number,
      bairro: this.form.value.neighborhood,
      cidade: this.form.value.city,
      estado: this.form.value.state,
      pais: this.form.value.country,
      latitude: this.form.value.latitude,
      longitude: this.form.value.longitude,
      address: `${this.form.value.neighborhood}, ${this.form.value.number} , ${this.form.value.city} - ${this.form.value.state}`,
    };
    this.itemsList[this.editIndex] = item;
    this.itemsList = [...this.itemsList];
    this.editIndex = null;
    this.form.reset();
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {


        local: this.form.controls['local'].value ?? '',
        tipo_endereco: this.getAddressTypeDescription(),
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    } else {
      return {


        local: this.form.controls['local'].value ?? '',
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    }
  }


  addItemToList() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }


    const itemPropostaId = this.data?.contratoItemId ? this.data.contratoItemId : 0;


    const newItem = {
      ordemServicoId: this.data.idOs,
      localParada: this.form.value.local || 'Novo Local',
      cep: this.form.value.postalCode || '',
      logradouro: this.form.value.street || '',
      numero: this.form.value.number || '',
      bairro: this.form.value.neighborhood || '',
      complemento: '',
      cidade: this.form.value.city || '',
      estado: this.form.value.state || '',
      latitude: this.form.value.latitude ? Number(this.form.value.latitude) : 0,
      longitude: this.form.value.longitude ? Number(this.form.value.longitude) : 0,
      dataCriacao: new Date().toISOString().split('T')[0],

      horaCriacao: new Date().toLocaleTimeString(),

      criadoPor: 2,
      trecho: 'P',
      areaTarifario: 'S',
      pais: this.form.value.country || 'Brasil'
    };

    this.loading = true;


    this.ordemService.createServiceOrderItinerary(newItem).subscribe({
      next: (res) => {
        this.loading = false;

        this.dialog.getDialogById('itinerary-service-order-modal')?.close({
          success: true,
          newItem: res.data || newItem
        });
      },
      error: (err) => {
        this.loading = false;

        this.dialog.getDialogById('itinerary-service-order-modal')?.close({
          success: false,
          error: err
        });
      }
    });
  }




  deleteItem(item: any) {
    this.itemsList = this.itemsList.filter(i => i.id !== item.id);
  }




}
